import { useEffect, useState } from 'react'
import { Query } from '../../../hooks/queries'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import {
  getNewNotificationsCount,
  NewNotificationsCountArgs
} from './queries/get-new-notifications-count'

export interface UseNewNotificationsCountQueryProps {
  organizationUuid: string
  isMenuOpen: boolean
  refetchInterval?: number
}

export type UseNewNotificationsCountQuery = (
  props: UseNewNotificationsCountQueryProps
) => number

export const useNewNotificationsCountQuery: UseNewNotificationsCountQuery = ({
  organizationUuid,
  refetchInterval = 15000,
  isMenuOpen
}: UseNewNotificationsCountQueryProps) => {
  const [enabled, setEnabled] = useState(true)

  const { data: newCount, error } = useContrastQuery<
    NewNotificationsCountArgs,
    number
  >(
    [Query.NEW_NOTIFICATIONS_COUNT, organizationUuid],
    getNewNotificationsCount,
    {
      organizationUuid
    },
    {
      enabled: enabled && !isMenuOpen,
      refetchInterval,
      notifyOnChangeProps: 'tracked'
    }
  )

  useEffect(() => {
    if (error) {
      setEnabled(false)
    }
  }, [error, setEnabled])

  return typeof newCount === 'undefined' ? 0 : newCount
}
